module.exports = __webpack_public_path__ + "static/media/starfish.835a0cb0.png";